import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// Tanner drying frame — A-frame posts with a stretched hide panel.
const build: (ctx: DecoBuildCtx) => void = ({ box, seed }) => {
  const wood = shade(0x6b5334, (rand(seed) - 0.5) * 0.1);
  const hide = shade(0xa67c52, (rand(seed + 1) - 0.5) * 0.14);
  // Legs
  box(-0.55, 0.85, -0.35, 0.1, 1.7, 0.1, wood);
  box(0.55, 0.85, -0.35, 0.1, 1.7, 0.1, wood);
  box(-0.55, 0.85, 0.35, 0.1, 1.7, 0.1, wood);
  box(0.55, 0.85, 0.35, 0.1, 1.7, 0.1, wood);
  // Crossbars
  box(0, 1.55, 0, 1.2, 0.1, 0.1, wood);
  box(0, 0.55, 0, 1.2, 0.1, 0.1, wood);
  box(0, 1.05, -0.35, 1.2, 0.08, 0.08, wood);
  box(0, 1.05, 0.35, 1.2, 0.08, 0.08, wood);
  // Hide panel
  box(0, 1.05, 0, 1.0, 1.15, 0.06, hide);
  box(0, 1.05, 0.04, 0.7, 0.85, 0.04, shade(hide, -0.1));
};

export default build;
